import {
  ON_SELECT_CUSTOM_EVENTS_CLICKED,
  ON_SELECT_CUSTOM_EVENTS_CLOSED,
  ON_SELECT_CUSTOM_EVENT_TOGGLED,
  ON_SELECT_CUSTOM_EVENTS_SELECT_ALL_TOGGLED,
  ON_SELECTED_CURRENCY_CHANGE,
  ON_SELECT_CUSTOM_EVENTS_COMPLETE,
  ON_SHOW_ALL_EVENTS_CLICKED
} from '../actions';

const initialState = {
  isOpen: false,
  selected: [], // <-- list of slugs
  events: {} // <-- hash of events by ID => { eventIdOne: { id: 'eventIdOne', title: 'MyEvent' ... } }
};

export default (state = initialState, action) => {
  if (action.type === ON_SHOW_ALL_EVENTS_CLICKED) {
    return initialState;
  }
  else if (action.type === ON_SELECT_CUSTOM_EVENTS_CLICKED) {
    return { ...state, isOpen: true };
  }
  else if (action.type === ON_SELECT_CUSTOM_EVENTS_CLOSED || action.type === ON_SELECT_CUSTOM_EVENTS_COMPLETE) {
    return { ...state, isOpen: false };
  }
  else if (action.type === ON_SELECT_CUSTOM_EVENT_TOGGLED) {
    let newEvents = null;
    let newSelected = state.selected;
    const idxToRemove = state.selected.indexOf(action.payload.slug);

    // remove the slug from our list, and remove the event from our hash
    if (idxToRemove !== -1) {
      newSelected = state.selected.filter((e, idx) => idx !== idxToRemove);
      const newEventIds = Object.keys(state.events).filter(eventId => eventId !== action.payload.event.id);
      newEvents = newEventIds.reduce((events, id) => {
        events[id] = state.events[id];
        return events;
      }, {});
    }
    else {
      // add the slug to our list, and add the event to our hash
      newSelected = state.selected.concat(action.payload.slug);
      newEvents = Object.assign({}, state.events, {
        [action.payload.event.id]: action.payload.event
      });
    }

    return {
      ...state,
      selected: newSelected,
      events: newEvents
    };
  }
  else if (action.type === ON_SELECT_CUSTOM_EVENTS_SELECT_ALL_TOGGLED) {
    let newEvents = {};
    let newSelected = state.selected;

    if (action.meta.addToState) {
      // no dupes - using a set for simplicity
      const setOfSlugs = new Set(newSelected);
      action.payload.slugs.forEach(slug => setOfSlugs.add(slug));
      newSelected = [...setOfSlugs];

      // merge our old events with the new one, removes dupes 👍
      newEvents = { ...state.events, ...action.payload.events };
    }
    else {
      newSelected = newSelected.filter(eventId => action.payload.slugs.indexOf(eventId) === -1);

      const idsToRemove = Object.keys(action.payload.events);
      const newEventIds = Object.keys(state.events).filter(eventId => idsToRemove.indexOf(eventId) === -1);
      newEvents  = newEventIds.reduce((events, id) => {
        events[id] = state.events[id];
        return events;
      }, {});
    }

    return {
      ...state,
      selected: newSelected,
      events: newEvents
    };
  }
  else if (action.type === ON_SELECTED_CURRENCY_CHANGE) {
    return {
      ...state,
      selected: [],
      events: {}
    };
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/selected-events-modal.js